const ListPeriodicidad = [
  {
    label: 'Selecciona',
    value: '',
  },
  {
    label: 'diario',
    value: '01'
  },
  {
    label: 'semanal',
    value: '02'
  },
  {
    label: 'quincenal',
    value: '03'
  },
  {
    label: 'mensual',
    value: '04'
  },
  {
    label: 'bimestral',
    value: '05'
  },
  {
    label: 'individual',
    value: '99'
  },
];

export default ListPeriodicidad;